"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.YES_DO_UPSELL = exports.NO_PREMIUM_FEATURES = exports.formats = exports.iconUses = exports.steps = exports.licensesDisplay = exports.licenses = exports.phasesDisplay = exports.phases = exports.constToCSS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _steps, _reducers;

var _merge = require("lodash/merge");

var _merge2 = _interopRequireDefault(_merge);

var _get = require("lodash/get");

var _get2 = _interopRequireDefault(_get);

var _includes = require("lodash/includes");

var _includes2 = _interopRequireDefault(_includes);

var _actionTypes = require("../actions/actionTypes");

var actionTypes = _interopRequireWildcard(_actionTypes);

var _actions = require("../actions/actions");

var actions = _interopRequireWildcard(_actions);

var _raven_client = require("../legacy/helpers/raven_client");

var _raven_client2 = _interopRequireDefault(_raven_client);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var constToCSS = exports.constToCSS = function constToCSS(constant) {
    return constant && constant.toLowerCase().replace(/[_\.]/g, "-");
};

// Fake action to allow phase specific reducers to initialize themselves
var ENTERING_STATE = "ENTERING_STATE";

var phases = exports.phases = {
    INITIAL: "INITIAL",
    SELECT_LICENSE: "SELECT_LICENSE",
    PAYMENT: "PAYMENT",
    ATTRIBUTION: "ATTRIBUTION",
    DOWNLOAD_READY: "DOWNLOAD_READY"
};

var phasesDisplay = exports.phasesDisplay = {
    SELECT_LICENSE: "License",
    PAYMENT: "Payment",
    ATTRIBUTION: "Attribution",
    DOWNLOAD_READY: "Download"
};

var licenses = exports.licenses = {
    ROYALTY_FREE: "ROYALTY_FREE",
    CREATIVE_COMMONS: "CREATIVE_COMMONS",
    PUBLIC_DOMAIN: "PUBLIC_DOMAIN",
    NOUN_PRO: "NOUN_PRO",
    ALREADY_PURCHASED_ROYALTY_FREE: "ALREADY_PURCHASED_ROYALTY_FREE"
};

var licensesDisplay = exports.licensesDisplay = {
    ROYALTY_FREE: {
        title: "Pro Download",
        description: "No need to give credit",
        notes: [{
            className: "pro-blue ui_eye-dropper",
            text: "Download in any color!"
        }, "$1.99 Royalty–Free License", "No need to attribute the icon,\nyour payment directly supports this creator."],
        thankYouTitle: "Thanks for your purchase!",
        thankYouText: "Your purchase supports the creator and you get to use it however you like."
    },
    CREATIVE_COMMONS: {
        title: "Basic Download",
        description: "Creative Commons",
        notes: [{
            className: "ui_close weight-medium color-black",
            text: "No editing features, download only in black"
        }, "$0 Creative Commons License", "Must attribute the creator of this icon\nper license requirements"]
    },
    PUBLIC_DOMAIN: {
        title: "Public Domain",
        description: "Public Domain",
        notes: ["Change icon color"]
    },
    NOUN_PRO: {
        thankYouTitle: "Thanks for signing up for NounPro!",
        description: "No need to attribute, you're NounPro",
        thankYouText: "Enjoy unlimited access to over 1 million icons, and be sure to check out out our <a target='_blank' href='/apps'>apps</a>!",
        title: "Royalty-Free",
        notes: ["Change icon color"]
    },
    ALREADY_PURCHASED_ROYALTY_FREE: {
        title: "Royalty-Free",
        description: "No need to give credit",
        notes: ["Change icon color"]
    }
};

var steps = exports.steps = (_steps = {}, _defineProperty(_steps, licenses.ROYALTY_FREE, [phases.INITIAL, phases.SELECT_LICENSE, phases.PAYMENT, phases.DOWNLOAD_READY]), _defineProperty(_steps, licenses.CREATIVE_COMMONS, [phases.INITIAL, phases.SELECT_LICENSE, phases.ATTRIBUTION, phases.DOWNLOAD_READY]), _defineProperty(_steps, licenses.NOUN_PRO, [phases.DOWNLOAD_READY]), _defineProperty(_steps, licenses.PUBLIC_DOMAIN, [phases.DOWNLOAD_READY]), _defineProperty(_steps, licenses.ALREADY_PURCHASED_ROYALTY_FREE, [phases.DOWNLOAD_READY]), _steps);

var iconUses = exports.iconUses = {
    web: {
        title: "On a website",
        instructions: ["Use the embedded attribution only if the icon is larger than 100px.", "Copy the attribution text below and include it in a bibliography or image caption."]
    },
    publication: {
        title: "For a publication",
        instructions: ["Use the embedded attribution only if the icon is larger than 100px.", "Copy the attribution text below and include it in a bibliography or image caption."]
    },
    inspiration: {
        title: "For inspiration",
        instructions: ["Use the embedded attribution only if the icon is larger than 100px.", "Copy the attribution text below and include it in a bibliography or image caption."]
    },
    document: {
        title: "In a presentation or document",
        instructions: ["Use the embedded attribution only if the icon is larger than 100px.", "Copy the attribution text below and include it in a bibliography or image caption."]
    },
    art: {
        title: "For an art project",
        instructions: ["Use the embedded attribution only if the icon is larger than 100px.", "Copy the attribution text below and include it in a bibliography or image caption."]
    },
    product: {
        title: "On a product I'm selling",
        instructions: ["Use the embedded attribution if the icon is larger than 100px.", "Copy the attribution text below and include it somewhere visible on the item or on a tag.", {
            url: "https://thenounproject.zendesk.com/hc/en-us/articles/200562967-Can-I-use-icons-in-Items-for-Resale-",
            text: "Learn more about icons on products for sale"
        }]
    },
    branding: {
        title: "For a logo or brand guide",
        instructions: ["Copy the attribution text below and include it underneath your brand mark. You may not trademark icons you have downloaded from Noun Project. The designer of the original icon holds all the work.", {
            url: "https://thenounproject.zendesk.com/hc/en-us/articles/203605383-Can-I-trademark-an-icon-to-use-for-my-business-logo-",
            text: "Learn more about icons in branding"
        }]
    },
    none: {
        title: "None of the above",
        instructions: ["Use the embedded attribution only if the icon is larger than 100px.", "Copy the attribution text below and include it in a bibliography or image caption.", {
            url: "https://thenounproject.zendesk.com/hc/en-us/articles/200509928-How-do-I-give-creators-credit-in-my-work-",
            text: "Learn more about giving credit"
        }]
    }
};

var formats = exports.formats = ["png", "svg"];

// Modal decision constants
var NO_PREMIUM_FEATURES = exports.NO_PREMIUM_FEATURES = "NO_PREMIUM_FEATURES";
var YES_DO_UPSELL = exports.YES_DO_UPSELL = "YES_DO_UPSELL";

var initialPhase = function initialPhase(state) {
    var license = state.license,
        isPremiumUser = state.isPremiumUser,
        iconBaseLicense = state.iconBaseLicense,
        loggedIn = state.loggedIn;

    if (!license) {
        license = licenses.ROYALTY_FREE;
    }

    if (isPremiumUser) {
        license = licenses.NOUN_PRO;
    }

    if (iconBaseLicense == licenses.PUBLIC_DOMAIN) {
        if (!loggedIn) {
            return phases.INITIAL;
        }
    }

    return steps[license][0];
};

var nextPhase = function nextPhase(status, license) {
    if (!license) {
        license = licenses.ROYALTY_FREE;
    }

    var licenseFlow = steps[license];

    var currentIndex = licenseFlow.indexOf(status);

    var nextIndex = Math.min(licenseFlow.length - 1, currentIndex + 1);
    return licenseFlow[nextIndex];
};

var reducers = (_reducers = {}, _defineProperty(_reducers, phases.INITIAL, function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];
    var status = state.status,
        isPremiumUser = state.isPremiumUser;


    if (!status) {
        status = getInitialPhase(state);
    }

    switch (action.type) {
        case actionTypes.GET_CURRENT_USER_SUCCESS:
            {
                var waitingForAuth = state.waitingForAuth,
                    license = state.license;

                if (state.active && waitingForAuth) {
                    status = nextPhase(status, license);
                    waitingForAuth = false;
                }

                var user = action.response;
                var loggedIn = !user.is_anonymous;

                return _extends({}, state, {
                    waitingForAuth: waitingForAuth,
                    status: status,
                    license: license,
                    loggedIn: loggedIn
                });
            }
        case actionTypes.DOWNLOAD_REQUEST:
            {
                var _user = action.user;
                var _license = state.license;


                var _waitingForAuth = void 0;
                if (_user && !_user.is_anonymous) {
                    status = nextPhase(status, _license);
                } else {
                    _waitingForAuth = true;
                }

                return _extends({}, state, {
                    waitingForAuth: _waitingForAuth,
                    status: status
                });
            }
    }

    return _extends({}, state, { status: status });
}), _defineProperty(_reducers, phases.SELECT_LICENSE, function (state, action) {
    var status = state.status;


    switch (action.type) {
        case actionTypes.DOWNLOAD_SELECT_LICENSE:
            {
                var license = action.license;

                var error = null;
                if (state.usingPremiumFeatures && license != licenses.ROYALTY_FREE) {
                    action.asyncDispatch(actions.downloadUpsellFlow(state.pendingDownload));
                    return _extends({}, state, {
                        error: error
                    });
                }
                return _extends({}, state, {
                    license: license,
                    status: status,
                    error: error
                });
            }
        case actionTypes.DOWNLOAD_COMMIT_LICENSE:
            {
                var _license2 = state.license,
                    _error = state.error;

                if (_license2) {
                    status = nextPhase(status, _license2);
                } else {
                    _error = "Please select a license.";
                }
                return _extends({}, state, {
                    status: status,
                    error: _error
                });
            }
    }

    return _extends({}, state, { status: status });
}), _defineProperty(_reducers, phases.ATTRIBUTION, function (state, action) {
    var status = state.status;

    switch (action.type) {
        case actionTypes.DOWNLOAD_SELECT_ATTRIBUTION:
            {
                var attributionType = action.attributionType;

                var error = void 0;
                return _extends({}, state, {
                    attributionType: attributionType,
                    status: status,
                    error: error
                });
            }
        case actionTypes.DOWNLOAD_COMMIT_ATTRIBUTION:
            {
                var _error2 = void 0;
                if (state.attributionType) {
                    var license = state.license;

                    status = nextPhase(status, license);
                    _error2 = null;
                } else {
                    _error2 = "Please select a use type.";
                }

                return _extends({}, state, {
                    status: status,
                    error: _error2
                });
            }
    }
}), _defineProperty(_reducers, phases.DOWNLOAD_READY, function (state, action) {
    var status = state.status,
        processing = state.processing,
        error = state.error;

    switch (action.type) {
        case ENTERING_STATE:
            {
                var license = state.license,
                    isPremiumUser = state.isPremiumUser,
                    iconBaseLicense = state.iconBaseLicense;


                if (iconBaseLicense == licenses.PUBLIC_DOMAIN) {
                    license = licenses.PUBLIC_DOMAIN;
                } else if (isPremiumUser) {
                    license = licenses.NOUN_PRO;
                }

                return {
                    license: license
                };
            }
        case actionTypes.DOWNLOAD_START:
            {
                processing = true;
                var fileType = action.fileType;

                return _extends({}, state, {
                    status: status,
                    processing: processing,
                    format: fileType
                });
            }
        case actionTypes.DOWNLOAD_START_FAILURE:
            {
                var _error3 = action.error;


                if (typeof _error3 != "string") {
                    _error3 = "Something went wrong with your download.";
                }
                processing = false;
                var format = null;
                return _extends({}, state, {
                    processing: processing,
                    error: _error3,
                    format: format
                });
            }
        case actionTypes.DOWNLOAD_START_SUCCESS:
            {
                processing = true;
                error = null;

                var response = action.response,
                    imgColor = action.imgColor,
                    _fileType = action.fileType;
                var fileUrl = response.download;


                return _extends({}, state, {
                    processing: processing,
                    fileUrl: fileUrl,
                    error: error,
                    format: _fileType
                });
            }
        case actionTypes.DOWNLOAD_COMPLETE_FAILURE:
            {
                processing = false;
                var _error4 = action.error;


                if (typeof _error4 != "string") {
                    _error4 = "Something went wrong with your download.";
                }
                return _extends({}, state, {
                    error: _error4,
                    processing: processing,
                    format: null
                });
            }
        case actionTypes.DOWNLOAD_COMPLETE_SUCCESS:
            {
                processing = false;
                return _extends({}, state, {
                    processing: processing,
                    format: null
                });
            }
    }

    return _extends({}, state, {
        status: status
    });
}), _defineProperty(_reducers, phases.PAYMENT, function (state, action) {
    var status = state.status,
        processing = state.processing,
        error = state.error,
        license = state.license;

    switch (action.type) {
        case ENTERING_STATE:
            {
                if (!global.Stripe) {
                    _raven_client2.default.captureMessage("Stripe not available for download flow.");
                    return {
                        error: "Could not connect to Stripe, please disable any active browser extensions and reload the page. If the problem persists, let us know at info@thenounproject.com"
                    };
                }
                if (state.savedCard) {
                    return {
                        purchaseTypeKey: "alacarte"
                    };
                } else {
                    return {
                        purchaseTypeKey: "pro.yearly"
                    };
                }
            }
        case actionTypes.DOWNLOAD_SELECT_PURCHASE_TYPE:
            {
                if (processing) {
                    return state;
                }

                var purchaseTypeKey = action.purchaseTypeKey;

                var _error5 = null;
                return _extends({}, state, {
                    purchaseTypeKey: purchaseTypeKey,
                    error: _error5
                });
            }
        case actionTypes.DOWNLOAD_PURCHASE_START:
            {
                processing = true;
                error = null;
                return _extends({}, state, {
                    processing: processing,
                    error: error
                });
            }
        case actionTypes.DOWNLOAD_PURCHASE_END:
            {
                var _error6 = action.error;

                var hasPurchased = void 0;
                if (!_error6) {
                    status = nextPhase(status, license);
                    hasPurchased = true;
                }

                processing = false;
                return _extends({}, state, {
                    processing: processing,
                    status: status,
                    error: _error6,
                    hasPurchased: hasPurchased
                });
            }
        case actionTypes.DOWNLOAD_PURCHASE_SUCCESS:
            {
                var purchase = action.purchase;
                var isPremiumUser = state.isPremiumUser,
                    purchasedIcons = state.purchasedIcons;


                if (purchase.type == "pro") {
                    isPremiumUser = true;
                }

                purchasedIcons = purchasedIcons || [];
                purchasedIcons.push(parseInt(state.pendingDownload.id));

                return _extends({}, state, {
                    isPremiumUser: isPremiumUser,
                    purchasedIcons: purchasedIcons,
                    hasPurchased: true,
                    justPurchased: true
                });
            }
    }

    return _extends({}, state, {
        status: status
    });
}), _reducers);

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    var status = state.status;

    var newState = _extends({}, state);

    // Reducer for global non phase specific actions
    switch (action.type) {
        case actionTypes.DOWNLOAD_RESET_FLOW:
            {
                return {
                    usingPremiumFeatures: state.usingPremiumFeatures,
                    isPremiumUser: state.isPremiumUser,
                    savedCard: state.savedCard,
                    purchasedIcons: state.purchasedIcons,
                    loggedIn: state.loggedIn
                };
            }
        case actionTypes.STRIPE_CARD_INPUT_CHANGE:
        case actionTypes.DOWNLOAD_FLOW_GO_BACK:
            {
                newState.error = null;
                break;
            }
        case actionTypes.GET_CURRENT_USER_SUCCESS:
            {
                var user = action.response;
                var isPremiumUser = user.permissions && user.permissions.market == "premium";
                var loggedIn = !user.is_anonymous;
                var savedCard = user.has_credit_card;

                var license = newState.license;

                if (isPremiumUser) {
                    license = licenses.NOUN_PRO;
                    status = nextPhase(status, license);
                }

                Object.assign(newState, {
                    isPremiumUser: isPremiumUser,
                    savedCard: savedCard,
                    loggedIn: loggedIn,
                    license: license,
                    status: status
                });

                if (loggedIn && !isPremiumUser) {
                    action.asyncDispatch(actions.iconsFetchPurchased());
                }
                break;
            }
        case actionTypes.SET_ICON_COLOR_PALETTE:
            {
                var color = action.color;

                var isNotBlack = color.selectedColor.hex != "#000000" && color.selectedColor.hex != "black";
                var isNotFromStorage = !color.selectedColor.colorFromStorage;
                if (state.pendingDownload) {
                    var purchaseTypeKey = state.purchaseTypeKey,
                        _hasPurchased = state.hasPurchased,
                        _isPremiumUser = state.isPremiumUser;

                    var notBuyingPro = !purchaseTypeKey || purchaseTypeKey.indexOf("pro") < 0;
                    var appropriatePhase = status == phases.SELECT_LICENSE || status == phases.ATTRIBUTION || status == phases.DOWNLOAD_READY;
                    var hasSelectedNonRoyaltyFreeLicense = !!state.license && state.license == licenses.CREATIVE_COMMONS;

                    if (isNotBlack && !_isPremiumUser && !_hasPurchased && notBuyingPro && isNotFromStorage && appropriatePhase && hasSelectedNonRoyaltyFreeLicense) {
                        action.asyncDispatch(actions.downloadUpsellFlow(state.pendingDownload));
                    }
                }

                return _extends({}, state, {
                    usingPremiumFeatures: isNotBlack && isNotFromStorage
                });
            }
        case actionTypes.DOWNLOAD_SET_FLOW_ACTIVE:
            {
                var _isPremiumUser2 = state.isPremiumUser;
                var icon = action.icon;


                var licenseDescription = icon.license_description;
                var _license3 = void 0,
                    _hasPurchased2 = void 0;

                var iconBaseLicense = licenses.CREATIVE_COMMONS;
                if (licenseDescription == "public-domain") {
                    iconBaseLicense = licenses.PUBLIC_DOMAIN;
                    _license3 = iconBaseLicense;
                }

                var userHasPurchased = icon.userHasPurchased || (0, _includes2.default)(state.purchasedIcons, parseInt(icon.id));
                if (iconBaseLicense != licenses.PUBLIC_DOMAIN) {
                    if (_isPremiumUser2) {
                        _license3 = licenses.NOUN_PRO;
                    } else if (userHasPurchased && state.hasPurchased !== false) {
                        // User is not repurchasing RF license
                        _license3 = licenses.ALREADY_PURCHASED_ROYALTY_FREE;
                        _hasPurchased2 = true;
                    } else if (iconBaseLicense == licenses.CREATIVE_COMMONS) {
                        // Default to RF selected
                        _license3 = licenses.ROYALTY_FREE;
                    }
                }

                Object.assign(newState, _extends({}, state, {
                    active: true,
                    pendingDownload: icon,
                    license: _license3,
                    iconBaseLicense: iconBaseLicense,
                    hasPurchased: _hasPurchased2,
                    status: status
                }));

                status = initialPhase(newState);
                newState.status = status;
                break;
            }
        case actionTypes.FETCH_SVG_DATA_SUCCESS:
            {
                var iconId = action.iconId,
                    _response = action.response;
                var _pendingDownload = state.pendingDownload;


                if (_pendingDownload && _pendingDownload.id == iconId) {
                    _pendingDownload = _extends({}, _pendingDownload, {
                        raw_svg: _response
                    });
                }

                return _extends({}, state, {
                    pendingDownload: _pendingDownload
                });
            }
        case actionTypes.DOWNLOAD_SET_PREVIEW_ATTRIBUTION:
            {
                var _iconId = action.iconId,
                    value = action.value;


                var previewAttribution = !state.previewAttribution;

                return _extends({}, state, {
                    previewAttribution: previewAttribution
                });
            }
        case actionTypes.DOWNLOAD_REPURCHASE:
            {
                var _hasPurchased3 = false;
                return _extends({}, state, {
                    hasPurchased: _hasPurchased3,
                    isRepurchasing: true
                });
            }

        case actionTypes.ICONS_FETCH_PURCHASED_SUCCESS:
            var response = action.response;
            var icon_ids = response.icon_ids;
            var pendingDownload = state.pendingDownload,
                hasPurchased = state.hasPurchased;


            if (pendingDownload) {
                if ((0, _includes2.default)(icon_ids, pendingDownload.id)) {
                    hasPurchased = true;
                }
            }

            return _extends({}, state, {
                purchasedIcons: icon_ids,
                hasPurchased: hasPurchased
            });
        case "APOLLO_QUERY_RESULT":
            {
                // If visitor was logged out, clicked download button, logged in
                // with account that owns license, update hasPurchased and don't
                // ask them to pay again
                var operationName = action.operationName;

                if (operationName == "IconDetailQuery") {
                    var _icon = (0, _get2.default)(action, "result.data.iconDetail");
                    var _pendingDownload2 = state.pendingDownload,
                        _status = state.status,
                        _license4 = state.license,
                        _isPremiumUser3 = state.isPremiumUser;

                    if (_icon && _pendingDownload2 && _icon.id == _pendingDownload2.id) {
                        _pendingDownload2 = _extends({}, _pendingDownload2, _icon);

                        var _hasPurchased4 = _pendingDownload2.userHasPurchased;

                        if (_hasPurchased4 && _hasPurchased4 != state.hasPurchased && !_isPremiumUser3) {
                            _license4 = licenses.ALREADY_PURCHASED_ROYALTY_FREE;
                            _status = nextPhase(_status, _license4);
                        }

                        Object.assign(newState, _extends({}, state, {
                            pendingDownload: _pendingDownload2,
                            hasPurchased: _hasPurchased4,
                            status: _status,
                            license: _license4
                        }));
                        break;
                    }
                }
            }
    }

    if (reducers[status]) {
        Object.assign(newState, reducers[status](newState, action));
    }

    if (!newState) {
        console.warn("Download store no newState, from", status);
        return state;
    }

    if (newState.status != state.status) {
        var initializeNewPhase = reducers[newState.status](newState, {
            type: ENTERING_STATE
        });
        Object.assign(newState, initializeNewPhase);

        if (action.asyncDispatch) {
            // Dispatch an action in case other reducers are interested in state transition
            action.asyncDispatch(_extends({
                type: "DOWNLOAD_ENTER_PHASE_" + newState.status
            }, initializeNewPhase));
        }
    }

    return newState;
};